import { useService } from 'react-reservice';

import { pickProperties } from '@aqx-core/common/services/utils';

import { IEquityChartServiceContext, equityChartService } from './service';

export const useChartWithKeys = <K extends keyof IEquityChartServiceContext>(keys: K[]) => {
  return useService(equityChartService, (context) => {
    if (!context) {
      return {} as Pick<IEquityChartServiceContext, K>;
    }
    return pickProperties(context, keys);
  });
};

export const useOrderTrackers = () => {
  return useService(equityChartService, (context) => context.orderTrackers);
};

export const useIsOrderTracked = (orderId: string) => {
  return useService(equityChartService, (context) =>
    context.orderTrackers.some((tracker) => tracker.orderId === orderId)
  );
};

export const useAskPriceVisible = () => {
  return useService(equityChartService, (context) => context.askPriceVisible);
};

export const usePriceAlertsVisible = () => {
  return useService(equityChartService, (context) => context.priceAlertsVisible);
};

export const useTechnicalIndicators = () => {
  return useService(equityChartService, (context) => context.technicalIndicators);
};

export const useIsTechnicalIndicatorsLoading = () => {
  return useService(equityChartService, (context) => context.loadingIndicator);
};

export const useSelectedPeriod = () => {
  return useService(equityChartService, (context) => context.selectedPeriod);
};

export const useSelectedSeries = () => {
  return useService(equityChartService, (context) => context.selectedSeries);
};

export const useChartProvider = () => {
  return useService(equityChartService, (context) => context.selectedProvider);
};

export const useChartPreviewVisibility = () => {
  return useService(equityChartService, (context) => context.isChartPreviewVisible);
};

export const useIsChartLoading = (): boolean => {
  return useService(equityChartService, (context) => Boolean(context.isChartLoading));
};
